import { WbsItemType } from '../../../domain/entity/WbsItemEntity'
import { WbsItemTypeVO } from '../../../domain/value-object/WbsItemTypeVO'

export type WbsItemTypeCandidates = {
  wbsItemTypes: WbsItemTypeVO[]
  ticketListTypes: WbsItemTypeVO[]
  ticketTypes: WbsItemTypeVO[]
}

export type ParentWbsItemTypeSource = {
  type?: WbsItemType
  ticketType?: string
}

export const resolveParentWbsItemType = (
  source: ParentWbsItemTypeSource | undefined,
  candidates: WbsItemTypeCandidates
): WbsItemTypeVO | undefined => {
  if (!source) return undefined

  const { ticketType, type } = source
  if (ticketType) {
    const ticket = [
      ...candidates.ticketListTypes,
      ...candidates.ticketTypes,
    ].find(v => v.code === ticketType)
    if (ticket) return ticket
  }

  if (!type) return undefined
  return candidates.wbsItemTypes.find(v => v.rootType === type)
}
